import { Pill } from '@eventbrite/eds-pill';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/marmalade';
import React, { FunctionComponent, ReactElement } from 'react';
import './PromoCodePills.scss';
import { TagIcon } from './TagIcon';
import { UnlockedLockIcon } from './UnlockedLockIcon';

export interface PromoCodePillsProps {
    isBOGO: boolean;
    isDiscounted: boolean;
    isUnlocked: boolean;
    className: string;
}

const PromoPill = ({
    bgColor,
    icon,
    testId,
    text,
}: {
    bgColor: 'purple' | 'yellow';
    icon: ReactElement;
    testId?: string;
    text: GenericLazyString | string;
}) => (
    <Pill
        className="promo-code-pill"
        dataTestid={testId}
        color={bgColor}
        textColor="dark-grey"
    >
        <Icon size="xsmall">{icon}</Icon>
        <span className="promo-code-pill-text">{text}</span>
    </Pill>
);

const PromoCodePills: FunctionComponent<PromoCodePillsProps> = ({
    isBOGO,
    isDiscounted,
    isUnlocked,
    className,
}) => {
    const pillsArray = [];

    if (isBOGO) {
        pillsArray.push(
            <PromoPill
                key="bogo-pill"
                bgColor="yellow"
                icon={<TagIcon />}
                testId="bogo-pill"
                text={gettext('2 for 1 deal')}
            />,
        );
    }

    if (isDiscounted) {
        pillsArray.push(
            <PromoPill
                key="discounted-pill"
                bgColor="yellow"
                icon={<TagIcon />}
                testId="discounted-pill"
                text={gettext('Discount applied')}
            />,
        );
    }

    if (isUnlocked) {
        pillsArray.push(
            <PromoPill
                key="unlocked-pill"
                bgColor="purple"
                icon={<UnlockedLockIcon />}
                testId="unlocked-pill"
                text={gettext('Unlocked')}
            />,
        );
    }

    return pillsArray.length > 0 ? (
        <ul
            className={`promo-code-pills-wrapper ${className}`}
            data-testid="promo-code-pills"
        >
            {pillsArray}
        </ul>
    ) : null;
};

export default PromoCodePills;
